import PostLoader from '../../assets/img/loader.gif';
import React, { useEffect, useRef, useState } from "react";
import API from "../../Network/API";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { story_show } from '../../Network/EndPoint';
import { toast } from 'react-toastify';

export default function SingleStory(){
    let { id } = useParams();
    const dispatch=useDispatch();
    const auth_user = useSelector((state) => state.authReducer)
    const [prevPostId, setPrevPostId] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [currentPost, setCurrentPost] = useState(null);
    const [current_index, setCurrentIndex] = useState(0);
    const selector_story = useSelector((state) => state.storyReducer)
    const post_data = selector_story?.post_data;
    const [page, setPage] = useState(1);
    const [nextPostId, setNextPostId] = useState(null);
    const [set_like, setLike] = useState(0);
    const [love_react, setLoveReact] = useState(false);
    const [p_id_like, setPIDLike] = useState(0);
    const [message, setMessage] = useState(null);
    const inp_message=useRef();
    const [showViewers, setShowViewers] = useState(false);
    const [viewers, setViewers] = useState([]);
    const [viewersTotal, setViewersTotal] = useState(0);
    const [viewersLoading, setViewersLoading] = useState(false);
    // Story ids already reported as viewed this session, so navigating
    // back and forth doesn't re-fire the API for the same story.
    const viewedStoryIds = useRef(new Set());
    useEffect(() => {
        API.get(`${story_show}/${id}`).then(response => {
        }).catch((error) => {
        });
    }, [id]);

    // Record a view every time a new story becomes visible (prev/next
    // included). Own stories are skipped — owner opens don't count.
    useEffect(() => {
        setShowViewers(false);
        setViewersTotal(currentPost?.total_view ?? 0);
        if (!currentPost?.id || currentPost?.is_deletable === 1) {
            return;
        }
        if (viewedStoryIds.current.has(currentPost.id)) {
            return;
        }
        viewedStoryIds.current.add(currentPost.id);
        API.post("/v2/story_view", { story_id: currentPost.id }).catch(() => {});
    }, [currentPost]);

    const openViewers = () => {
        if (!currentPost?.id) return;
        setShowViewers(true);
        setViewersLoading(true);
        API.get(`/v2/story_viewers?story_id=${currentPost.id}`).then((response) => {
            const data = response?.data?.data || {};
            setViewers(data.viewers || []);
            setViewersTotal(data.total || 0);
            setViewersLoading(false);
        }).catch(() => {
            setViewersLoading(false);
        });
    };

    useEffect(() => {
      fetchCurrentPost(id);
  
  }, [id, post_data]);

  const fetchCurrentPost = (postId) => {
      const post = post_data?.find((post) => post.user_id === parseInt(postId, 10));
      setCurrentPost(post);
  };

  const handlePrevClick = () => {
    if (current_index < 0) {
        return;
    }
    const prevIndex = (current_index - 1 + post_data.length) % post_data.length;
    setCurrentIndex(current_index - 1);
    setPrevPostId(post_data[prevIndex].user_id);
    fetchCurrentPost(post_data[prevIndex].user_id);
};

const handleNextClick = () => {
  console.log(post_data.length)
  if (post_data.length < current_index) {
      return;
  }
  const nextIndex = (current_index + 1) % post_data.length;
  setCurrentIndex(current_index + 1);
  setNextPostId(post_data[nextIndex].user_id);
  fetchCurrentPost(post_data[nextIndex].user_id);
  const lastPageIndex = post_data.length - 1;

  if (lastPageIndex >= 0 && current_index == lastPageIndex) {
      setPage(page + 1)
  }

};

const postLike = (post_id) => {
  setLoading(true)
  setLoveReact(true)
  setLike(1)
  setPIDLike(post_id)
  API.post("/v2/story_love", {
    story_id: post_id,
  }).then((response) => {
      setLoading(false)
      setLoveReact(false)
      
  });
}

const sendMessage = (post_id) => {
  if(message==null || message==undefined){
    toast.error("Please say something");
    return;
  }
  setLoading(true)
  API.post("/v2/story_love", {
    story_id: post_id,
    message: message,
    type: 2,
  }).then((response) => {
    setLoading(false)
    setMessage("")
    inp_message.current.value="";
    toast.success("Message send successfully");
  }).catch((error) => {
    setLoading(false)
  });

}

    return (
        <>
        {selector_story?.loading? 
           <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center' }}>
           <img src={PostLoader} alt='Post loader' height={80} width={80} />
       </div>
        :
<section className="bg-black vh-100">
        <div className="daily-stories">
          <div className="daily-stories__outer">
            <div className="daily-stories__container">
              <div className="daily-stories-slide">
                <div className="story-main-image-bg" style={{ backgroundImage: `url(${currentPost?.image})` }} />
                <div className="daily-stories-user">
                  <div className="d-flex">
                    <div className="image">
                      <a href="javascript:void(0)">
                        <div className="user-picture-container rounded-circle" style={{ backgroundImage: `url(${currentPost?.avatar})`, objectFit: 'fill' }} />
                      </a>
                    </div>
                    <div className="info ms-2">
                      <span className="name d-block ">
                        <a href="javascript:void(0)" className="text-white"> {currentPost?.post_by}</a>
                      </span>
                      <small className="small-text text-white"><a href="javascript:void(0)" className="text-white">{currentPost?.last_seen}</a></small>
                    </div>
                  </div>
                </div>
                <div className="daily-stories-content">
                  <p>{currentPost?.message}</p>
                </div>
              </div>
              <div className="story-replay">
                {currentPost?.is_deletable === 1 ?
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center me-4" onClick={openViewers} style={{ cursor: 'pointer' }}>
                    <i className="fa-solid fa-eye text-white me-2" />
                    <span className="text-white">{viewersTotal} viewers</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <i className="fa-solid fa-heart i-loved me-2" />
                    <span className="like-count text-white">{currentPost?.total_love}</span>
                  </div>
                </div>
                :
                <div className="d-flex align-items-center">
                  <div className="story-replay-reaction-icon d-flex align-items-center me-3">
                    <div className="icon-wrap me-2">
                    {currentPost?.is_loved ?
                                        <i className="fa-solid fa-heart i-loved" />
                                        :
                                        <>
                                            <i onClick={() => postLike(currentPost?.id)} className={`fa-solid fa-heart clickable ${p_id_like == currentPost?.id ? 'i-loved' : ''}`} />
                                        </>
                                    }
                  
                    </div>
                    <span className="like-count">{currentPost?.total_love + (p_id_like == currentPost?.id ? set_like:0)}</span>
                  </div>
                  <div className="story-replay-input position-relative">
                    <input type="text" className="form-control story-replay-input-custom " placeholder="Write a message..." onChange={(e)=>setMessage(e.target.value)} ref={inp_message} defaultValue={message} />
                    <a href className="story-replay-send-btn position-absolute" onClick={()=>sendMessage(currentPost?.id)}>
                      
                      {isLoading ? (
                    <span
                        className="spinner-border spinner-border-sm ml-5"
                        role="status"
                        aria-hidden="true"
                    ></span>
                ) : (
                  <i className="fa-solid fa-paper-plane" />
                )}
                    </a>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        <span className="story-prev-slide" onClick={handlePrevClick}/>
        <span className="story-next-slide" onClick={handleNextClick}/>
        <div className="story-view-close-btn">
        <Link to={`/`}><i className="fa-solid fa-xmark"/></Link>
    </div>
        {showViewers &&
          <div
            onClick={() => setShowViewers(false)}
            style={{ position: 'fixed', inset: 0, zIndex: 1050, background: 'rgba(0,0,0,0.4)' }}>
            <div
              onClick={(e) => e.stopPropagation()}
              style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 480, maxHeight: '70vh', background: '#fff', borderRadius: '16px 16px 0 0', display: 'flex', flexDirection: 'column' }}>
              <div className="d-flex align-items-center justify-content-between px-3 py-3 border-bottom">
                <strong>{viewersTotal} viewers</strong>
                <i className="fa-solid fa-xmark" style={{ cursor: 'pointer' }} onClick={() => setShowViewers(false)} />
              </div>
              <div style={{ overflowY: 'auto', padding: '8px 0' }}>
                {viewersLoading ?
                  <div className="text-center py-4">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </div>
                  :
                  viewers.length === 0 ?
                    <div className="text-center text-muted py-4">No viewers yet</div>
                    :
                    viewers.map((viewer) => (
                      <div key={viewer.id} className="d-flex align-items-center px-3 py-2">
                        <div style={{ position: 'relative', marginRight: 12 }}>
                          <img src={viewer.avatar} alt={viewer.name} style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover' }} />
                          {viewer.is_loved &&
                            <i className="fa-solid fa-heart" style={{ position: 'absolute', right: -2, bottom: -2, color: '#e0245e', background: '#fff', borderRadius: '50%', padding: 2, fontSize: 12 }} />}
                        </div>
                        <div>
                          <div className="fw-bold">{viewer.name}</div>
                          {viewer.viewed_at && <small className="text-muted">{viewer.viewed_at}</small>}
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          </div>}
      </section>
}
        </>
    )

}